export default "__VITE_ASSET__Cv2Bok3o__"